export enum InviteUserFormTypes {
    Email= 'email',
    FirstName = 'first_name',
    LastName = 'last_name'
}